import ApiClient from '@/services/apiClient';
import ReaderFormat from '@/models/readerFormat';
import Delay from '@/models/delay';
import InputType from '@/models/inputType';

export default class ReaderDefaultConfig {
    reader_formats;
    push_button_input_type;
    door_contact_input_type;
    door_blocked_delay;
    opening_delay;

    constructor() {
      this.reader_formats = [ReaderFormat.haxoSecure()];
      this.push_button_input_type = "undefined";
      this.door_contact_input_type = "undefined";
      this.door_blocked_delay = new Delay(0, 's');
      this.opening_delay = new Delay(5, 's');
    }
  
    static constructFromObject(data, obj) {
      if (data) {
        obj = obj || new ReaderDefaultConfig();
        obj.reader_formats = ApiClient.convertToType(data['reader_formats'], [ReaderFormat]);
        obj.push_button_input_type =  InputType.constructFromObject(data['push_button_input_type']);
        obj.door_contact_input_type = InputType.constructFromObject(data['door_contact_input_type']);
        obj.door_blocked_delay = Delay.constructFromObject(data['door_blocked_delay']);
        obj.opening_delay = Delay.constructFromObject(data['opening_delay']);
      }
      return obj;
    }

    toJSON() {
      const json = {
        reader_formats: this.reader_formats
      };
      if (this.push_button_input_type != "undefined") {
        json.push_button_input_type = this.push_button_input_type;
      }
      if (this.door_contact_input_type != "undefined") {
        json.door_contact_input_type = this.door_contact_input_type;
        if(this.door_blocked_delay.value > 0) {
          json.door_blocked_delay = this.door_blocked_delay;
        }
      }
      if(this.opening_delay.value > 0) {
        json.opening_delay = this.opening_delay;
      }
      return json;
    }
}

  
